import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.parse-int.js";
export function isFunction(obj) {
  return typeof obj === "function";
}
export function isBoolean(obj) {
  return typeof obj === "boolean";
}
export function isString(obj) {
  return typeof obj === "string" || obj instanceof String;
}
export function isObject(v) {
  return v && _typeof(v) === "object" && !Array.isArray(v);
}
export function isNumeric(n) {
  if (Array.isArray(n) || isString(n)) {
    return false;
  }
  return !isNaN(parseFloat(n)) && isFinite(n);
}
export function isBlank(value) {
  if (isNumeric(value)) {
    return false;
  }
  // Boolean start check
  // Following ruby `.blank?` standards that true is false and false is true
  if (!value) {
    return true;
  }
  // We only have one branch here because we know it's true because of the !value check
  if (isBoolean(value)) {
    return false;
  }
  // Boolean end check
  if (isFunction(value)) {
    return false;
  }
  if (Array.isArray(value) || isString(value)) {
    return !value.length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  if (value instanceof HTMLElement) {
    return false;
  }
  return true;
}
function digitsOnly(str) {
  if (isBlank(str)) {
    return "";
  }
  return str.toString().replace(/\D/g, "");
}
export function numberWithCommas(number) {
  var value = digitsOnly(number);
  if (value.length > 3) {
    value = parseInt(value, 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return value;
}